export enum PaymentPlatform {
  Alipay = "ALI",
  AlipayFace = "ALIFACE",
  WeChat = "WX",
  Unknown = "UMKNOWN",
}

export interface PaymentRule {
  prefixes: string[]
  minLength: number
  maxLength: number
  platform: PaymentPlatform
}

export interface DateValueType {
  dateValue?: [string, string]
}

/**
 * 系统类型常量
 */
export const SystemTypeConstants = {
  /**
   * B端后台收银系统
   */
  B_CASHIER: 1,
  /**
   * B端小程序
   */
  B_MINI_PROGRAM: 2,
  /**
   * C端小程序
   */
  C_MINI_PROGRAM: 3,
  /**
   * S端后台管理系统
   */
  S_ADMIN: 4,
  /**
   * S端小程序
   */
  S_MINI_PROGRAM: 5,
} as const
